import React from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableCell,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#003366",
    color: theme.palette.common.white,
    padding: 1,
    fontSize: 12,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: 1,
  },
}));
const TableCardComponent = ({ fieldName, value }) => {
  const header = value[0];
  const filterOutELC = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(([key]) => !key.startsWith("ELC"))
    );
  };

  const filteredHeader = filterOutELC(header);
  let filteredObject;
  let filterData = [];

  const firstRowKeys = Object.keys(value?.[0] || {});

  value?.forEach((x) => {
    if (Object.values(x).some((x) => x?.length > 0)) {
      filteredObject = Object.fromEntries(
        Object.entries(x).filter(
          ([key, val]) =>
            !key.startsWith("ELC") &&
            (firstRowKeys.includes(key) || val?.length > 0)
        )
      );

      if (Object.keys(filteredObject).length > 0) {
        filterData.push(filteredObject);
      }
    }
  });

  return (
    <TableContainer component={Paper}>
      <b>
        <u>{fieldName}: </u>
      </b>
      <Table>
        <TableHead>
          <TableRow>
            {Object.keys(filteredHeader).map((value, index) => (
              <StyledTableCell className="cardTableCell" key={index}>
                {value}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {filterData.map((value, key) => (
            <TableRow key={key}>
              {Object.values(value).map((cellVal, index) => (
                <StyledTableCell className="cardTableCell" key={index}>
                  {cellVal !== null && typeof cellVal === "object" ? JSON.stringify(cellVal) : cellVal}
                </StyledTableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableCardComponent;
